export enum StakeButtonsModifiers  {
    Minus = "minus",
    Plus = "plus"
}